import { render, staticRenderFns } from "./DevLifeCycleModal.vue?vue&type=template&id=10901afe&"
import script from "./DevLifeCycleModal.vue?vue&type=script&lang=js&"
export * from "./DevLifeCycleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports